<template><section>
<div class="page">
  <div>
    <h2>
      Deleting contacts
    </h2>
    <p>
      To delete a contact from your contact list:
    </p>
    <ol>
      <li>
        Open ToTok and go to the <strong>Chats</strong> tab.
      </li>
      <li>
        Tap the "<strong>Contacts</strong>" icon at the top right
      </li>
      <li>
        Choose the contact you wish to delete.
      </li>
      <li>
        Tap "⋮" at the top right > <strong>Delete</strong> > <strong>OK</strong>.
      </li>
    </ol>


  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
